import { useMemo } from 'react';
import { isLocalMessage } from '../utils';
import { getReadStates } from '../utils';
export const useLastReadData = (props) => {
    const { messages, read, returnAllReadData, userID } = props;
    return useMemo(() => {
        const ownLocalMessages = messages.filter((msg) => isLocalMessage(msg) && msg.user?.id === userID);
        return getReadStates(ownLocalMessages, read, returnAllReadData);
    }, [messages, read, returnAllReadData, userID]);
};
